import React, { useState } from "react";

import { useIntl } from "react-intl";

import { ChipV4, TabsV4, type TabsV4Item } from "react-lib/apps/HISV4/common/ui";

// UX
import CardDrugTransferRequestQueue from "./CardDrugTransferRequestQueue";
import CardDrugTransferRequestHistory from "./CardDrugTransferRequestHistory";

// Stock
import CardStockManagement from "./CardStockManagement";
import CardStockTransferOrder from "./CardStockTransferOrder";

type StockTab = "stock" | "transfer" | "requestQueue" | "requestHistory";

const CardStockManagementTabs = (props: any) => {
  const [tab, setTab] = useState<StockTab>("stock");

  const intl = useIntl();

  const tabs: TabsV4Item<StockTab>[] = [
    { key: "stock", label: intl.formatMessage({ id: "การจัดการสินค้า" }) },
    {
      key: "transfer",
      label: (
        <>
          {intl.formatMessage({ id: "รายการโอนสินค้า (Transfer request)" })}
          {props.transferOrderCount > 0 && (
            <ChipV4 tone="danger-solid" size="sm">
              {props.transferOrderCount}
            </ChipV4>
          )}
        </>
      ),
    },
    { key: "requestQueue", label: intl.formatMessage({ id: "คิวใบขอยา" }) },
    { key: "requestHistory", label: intl.formatMessage({ id: "ประวัติการขอยา" }) },
  ];

  const handleChangeTab = (key: StockTab) => {
    setTab(key);

    if (key === "transfer") {
      props.setProp("transferOrderCount", 0);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: props.height ?? "100%",
        padding: "0.75rem 1.25rem 0",
      }}
    >
      <TabsV4 ariaLabel="Stock Management" items={tabs} active={tab} onChange={handleChangeTab} />

      <div style={{ flex: 1, minHeight: 0, overflow: "auto" }}>
        {tab === "stock" && (
          <CardStockManagement
            onEvent={props.onEvent}
            setProp={props.setProp}
            // seq
            runSequence={props.runSequence}
            StockManagementSequence={props.StockManagementSequence}
            // data
            selectedDivision={props.selectedDivision}
            // CommonInterface
            buttonLoadCheck={props.buttonLoadCheck}
            errorMessage={props.errorMessage}
            searchedItemListWithKey={props.searchedItemListWithKey}
            // options
            masterOptions={props.masterOptions}
            masterData={props.masterData}
            languageUX={props.languageUX}
          />
        )}

        {tab === "transfer" && (
          <CardStockTransferOrder
            onEvent={props.onEvent}
            setProp={props.setProp}
            // seq
            runSequence={props.runSequence}
            StockTransferOrderSequence={props.StockTransferOrderSequence}
            masterOptions={props.masterOptions}
            // CommonInterface
            buttonLoadCheck={props.buttonLoadCheck}
            errorMessage={props.errorMessage}
            selectedDivision={props.selectedDivision}
            languageUX={props.languageUX}
          />
        )}

        {tab === "requestQueue" && (
          <CardDrugTransferRequestQueue
            onEvent={props.onEvent}
            setProp={props.setProp}
            runSequence={props.runSequence}
            drugRequestList={props.drugRequestList}
            languageUX={props.languageUX}
          />
        )}

        {tab === "requestHistory" && (
          <CardDrugTransferRequestHistory
            onEvent={props.onEvent}
            runSequence={props.runSequence}
            masterOptions={props.masterOptions}
            setProp={props.setProp}
            DrugTransferRequestHistorySequence={props.DrugTransferRequestHistorySequence}
            DrugTransferRequestHistoryList={props.DrugTransferRequestHistoryList}
            languageUX={props.languageUX}
          />
        )}
      </div>
    </div>
  );
};

export default CardStockManagementTabs;
